import { FC, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import JSONPretty from 'react-json-pretty'
import { Loader } from '@liveconnect/communities-ui'

import { PublishedMessages } from '../../../../../core/publishedMessages/types'
import usePublishedMessages from '../../../../../core/publishedMessages/usePublishedMessages'
import useCulture from '../../../../../utils/culture'

import './styles.scss'

interface PublishedMessageDeatilModalProps {
  publishedMessage: PublishedMessages
  onClose: () => void
}

const PublishedMessageDeatilModal: FC<PublishedMessageDeatilModalProps> = ({
  publishedMessage,
  onClose,
}) => {
  const { t } = useTranslation()
  const { formatDate } = useCulture()
  const { detail, isDetailLoaded, fetchDetail } = usePublishedMessages()

  const getKeyValue = (key: string, value: string) => {
    return (
      <div className="KeyValue__field">
        <div className="KeyValue__field__key form-label">{key}</div>
        <div className="KeyValue__field__value">{value}</div>
      </div>
    )
  }

  useEffect(() => {
    fetchDetail(publishedMessage.key)
  }, [])

  return (
    <Modal
      show={true}
      onHide={onClose}
      className="PublishedMessagesDetailModal"
      centered
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {t('dashboard.publishedMessages.detail.title')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="DetailModal__data">
          <div className="DetailModal__row">
            {getKeyValue(
              t('dashboard.publishedMessages.list.table.id'),
              publishedMessage?.id
            )}
            {getKeyValue(
              t('dashboard.publishedMessages.list.table.key'),
              publishedMessage?.key
            )}
            {getKeyValue(
              t('dashboard.publishedMessages.list.table.eventType'),
              publishedMessage?.eventType
            )}
            {getKeyValue(
              t('dashboard.publishedMessages.list.table.retries'),
              publishedMessage?.retries.toString()
            )}{' '}
            {getKeyValue(
              t('dashboard.publishedMessages.list.table.createdAt'),
              publishedMessage?.createdAt
                ? formatDate(
                    new Date(publishedMessage.createdAt),
                    'LONG_DATE_TIME'
                  )
                : ''
            )}{' '}
            {getKeyValue(
              t('dashboard.publishedMessages.list.table.expires'),
              publishedMessage?.expires
                ? formatDate(
                    new Date(publishedMessage.expires),
                    'LONG_DATE_TIME'
                  )
                : ''
            )}{' '}
          </div>
        </div>
        {!isDetailLoaded ? (
          <Loader />
        ) : (
          <>
            {!!detail?.error &&
              getKeyValue(
                t('dashboard.publishedMessages.list.table.error'),
                detail?.error.toString()
              )}
            <div className="KeyValue__field">
              <div className="KeyValue__field__key form-label">
                {t('dashboard.publishedMessages.detail.data')}
              </div>
              <div className="KeyValue__field__json__value">
                {detail?.data && (
                  <JSONPretty id="json-pretty" data={detail?.data}></JSONPretty>
                )}
              </div>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default PublishedMessageDeatilModal
